import environmentConfig from './utils/configs';

const appVersion = import.meta.env.VITE_SENTRY_RELEASE || '0.0.0';
console.log('environmentConfig', environmentConfig);
const config = {
    EVENT_NAMESPACE: 'beststart-scorecard-web',
    audience: 'beststart-scorecard-web',
    gitBranch: null,
    version: appVersion,
    namespace: 'beststart-scorecard-web',
    tag: 'beststart-scorecard-web',
    env: import.meta.env.MODE,
    scorecardApiUrl: environmentConfig.scorecardApiUrl,
    employeeEmail: environmentConfig.employeeEmail || null,
    managerEmail: environmentConfig.managerEmail || null,
    LogLevel: environmentConfig.LogLevel || 0,
    sampleRate: environmentConfig.sampleRate || 0,
    sentry: environmentConfig.sentry || null,
    authentication: {
        clientId: environmentConfig.clientId,
        authority: environmentConfig.authority,
        authBaseUrl: environmentConfig.scorecardApiUrl,
        redirectUri: window.location.hostname === "localhost.lambdatest.com"
            ? 'https://localhost.lambdatest.com:50329/login'
            : `${window.location.origin}/login`,
    },
};

if (config.authentication.clientId?.startsWith('REPLACE_WITH_')) {
    console.error('[config] Production clientId has not been set — authentication will fail.');
}
console.log('config', config);
export default config;
